import CustomSegment from '@/components/CustomSegment';
import PageTitle from '@/components/PageTitle';
import { useSegment } from '@/hooks/useSegment';
import DashboardLayout from '@/layouts/DashboardLayout';
import type { SegmentedType } from '@/types/global.types';
import EvAssessment from './EvAssessment';
import EvInterview from './EvInterview';

type SegmentType = 'ev-assessment' | 'ev-interview';

const Evaluation = () => {
  const { segment, setSegment } = useSegment<SegmentType>(
    'evaluation',
    'ev-assessment',
    false,
  );

  const SEGMENT_CONFIG: SegmentedType<SegmentType>[] = [
    {
      value: 'ev-assessment',
      label: 'Assessment',
      view: <EvAssessment />,
    },
    {
      value: 'ev-interview',
      label: 'Interview',
      view: <EvInterview />,
    },
  ];

  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);
  return (
    <DashboardLayout title="Evaluation">
      <PageTitle
        classNames={{ root: 'items-start' }}
        title="Evaluation"
        items={[
          { title: 'Dashboard', path: '/admin/recruitment/dashboard' },
          { title: currentSegment?.label },
        ]}
      />

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
};

export default Evaluation;
